import { Component, Input } from '@angular/core';
import { InfoPanelGridCell } from '../info-panel-grid-cell';

@Component({
  selector: 'app-info-panel-list-field',
  standalone: true,
  imports: [],
  templateUrl: './info-panel-list-field.component.html',
  styleUrl: './info-panel-list-field.component.css',
})
export class InfoPanelListFieldComponent extends InfoPanelGridCell {
  @Input({ required: true }) label!: string;
  @Input() value: string[] | null | undefined;
}
